<template>
  <div class="content">
    <div class="header">
      <v-layout row wrap align-center class="hero" :style="header()">
        <v-container fluid>
          <v-row>
            <v-col cols="3"></v-col>
            <v-col cols="12" md="6" lg="6" xl="6" class="text-center">
              <h3 class="display-2 white--text pa-3 hidden-sm-and-down">
                Opening Our Minds to Our Brains’ Potential
              </h3>
              <h4 class="display-1 white--text pa-3 hidden-md-and-up">
                Opening Our Minds to Our Brains’ Potential
              </h4>
              <!-- <v-chip label color="white" text-color="black" active>New Release</v-chip> -->
              <p class="subtitle-1 white--text pa-3 hidden-sm-and-down">
                In her debut book, Angela Sette reveals the limitless
                possibilities that can be acquired when we learn to harness our
                own brainpower.
              </p>
              <p class="subtitle-2 white--text pa-3 hidden-md-and-up">
                In her debut book, Angela Sette reveals the limitless
                possibilities that can be acquired when we learn to harness our
                own brainpower.
              </p>
              <v-btn color="white" class="ma-2 black--text" href="/book">
                learn more
                <v-icon right dark>mdi-arrow-right</v-icon>
              </v-btn>
            </v-col>
            <v-col cols="3"></v-col>
          </v-row>
        </v-container>
      </v-layout>
    </div>

    <Subscribe />

    <!-- FIXME: Modify this code so that the columns change on resizong. There was a bug prior so I used 2 spereate declarations and hid them on differnet sizes.  -->
    <v-container>
      <v-row>
        <v-col cols="6" class="hidden-sm-and-down">
          <Title title="Angela Sette" subtitle="about" />
          <p class="pb-6">
            Angela Sette is a writer that taps into human potential stemming
            from our minds as well as our bodies. She is health Science
            educated, along with extensive experience as a mind-body movement
            specialist in Yoga, Pilates, Meditation and Dance. Angela had the
            privilege of working with high achievers, as well as those faced
            with physical and mental challenges.
          </p>
          <v-btn raised class="white--text" color="#b697ff" href="/about">
            READ MORE
            <v-icon right>mdi-arrow-right</v-icon>
          </v-btn>
        </v-col>
        <v-col cols="6" class="hidden-sm-and-down">
          <GeoImage />
        </v-col>
        <v-col cols="12" class="hidden-md-and-up">
          <Title title="Angela Sette" subtitle="about" />
          <p class="pb-6">
            Angela Sette is a writer that taps into human potential stemming
            from our minds as well as our bodies. She is health Science
            educated, along with extensive experience as a mind-body movement
            specialist in Yoga, Pilates, Meditation and Dance. Angela had the
            privilege of working with high achievers, as well as those faced
            with physical and mental challenges.
          </p>
          <v-btn raised class="white--text" color="#b697ff" href="/about">
            READ MORE
            <v-icon right>mdi-arrow-right</v-icon>
          </v-btn>
        </v-col>
        <v-col cols="12" class="hidden-md-and-up">
          <GeoImage />
        </v-col>
      </v-row>
    </v-container>

    <Certs />
  </div>
</template>

<script>
import Certs from "../components/Certifications";
import Title from "../components/Title";
import GeoImage from "../components/GeoImage";
import Subscribe from "../components/Subscribe";

export default {
  components: {
    Certs,
    Title,
    GeoImage,
    Subscribe
  },
  data() {
    return {
      background: require("@/assets/background.jpg")
    };
  },
  methods: {
    header() {
      return {
        backgroundImage: `url(${this.background})`
      };
    }
  }
};
</script>

<style lang="scss">
.content {
  background-color: #fff;

  .header {
    height: 100vh;
  }
  .hero {
    height: 100%;

    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    position: relative;
  }
}
</style>
